import * as mutationTypes from '@/store/mutation-types.js'
import stringOperations from '@/mixins/string-operations'
import dateOperations from '@/mixins/date-operations'
import basicOperations from '@/mixins/basic-operations.js'
import icons from '@/mixins/icons.js'

export default {
  name: 'WachtwoordVergeten',

  mixins: [basicOperations, stringOperations, dateOperations, icons],

  data() {
    return {
      isAndroidOrIOS: this._isAndroidOrIOS(),
      debugging: this.$store.state.debugging,
      userdata: {},
      Key: '',
      ID: '',
      PW: '',
      PW2: '',
      validPasswords: false,
      PWMin8: false,
      PWSpecialChars: false,
      melding: '',
      wachtwoordVergetenSucces: false,
      passwordsInfo: [],
      passwordFieldType: 'password',
      API: ''
      //'Test1!',
    }
  },

  computed: {
    nameOfUser() {
      return this._capitalizeFirstLetters(
        this.$store.state.userInfo.loggedInUserInformation.UserData.name
      )
    },
    isOuder() {
      return this.$store.state.userInfo.isOuder
    },

    serverLocation() {
      return this.$store.state.userInfo.loggedInConnectionObject.serverLocation
    }

  },

  mounted: function() {

    // Deze component opent altijd in Schoolware => bestaat niet in app versie!
    this.$store.state.userInfo.loggedInConnectionObject = {}
    this.$store.state.userInfo.loggedInConnectionObject.serverLocation = window.location.href.split('/vue/')[0]

    if (this.$store.state.api === '' || this.$store.state.api === undefined ) {
      this.$store.dispatch('apiCheck', {
        dezeDit: this,
        succesCallback: this.vervolgMounted
      })
    } else {
      this.vervolgMounted()
    }

  },

  methods: {
    setHomeurl(){
      this.$router.push("/");
    },
    vervolgMounted: function() {
      this.PWMin8 = this.$store.state.api.PWMin8
      this.PWSpecialChars = this.$store.state.api.PWSpecialChars

      var links = ''
      if (this.isAndroidOrIOS) {
        links = 'back'
      } else {
        // this.$store.commit(mutationTypes.SET_SHOW_TOP_LOGO, true)
      }

      this.$store.commit(mutationTypes.SET_MENUBAR_ITEMS, {
        left: links,
        title: 'Schoolware - Wachtwoord vergeten',
        right: []
      })
      this.userdata = this.$store.state.userInfo.loggedInUserInformation.UserData

      let params = window.location.href.split('Key=')[1].split('&')
      this.Key = params[0]
      this.ID = params[1].split('id=')[1]

      if (this.debugging) { // dummy debug data test
        this.passwordChanged()
      }
    },

    passwordChanged: function() {
      this.passwordsInfo = this._passwordValidation(this.PW, this.PW2, this.PWMin8, this.PWSpecialChars)
    },

    switchVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
    },

    resetPasswordConfirmation() {
      console.log('resetPasswordConfirmation')
      this.$store.dispatch('resetPasswordConfirmation', {
        dezeDit: this
      })
    },

  }
}
